export default {"src":"/_next/static/image/public/images/ic_flash_boy.689f95c22dd693bcaf2a17570c9ee6ca.svg","height":34,"width":36};